module.exports = __webpack_public_path__ + "img/996.83ea3be3.jpg";